import React, {useState} from "react";
import styled from "styled-components";
// Components
import BlogBox from "../Elements/BlogBox";
import FullButton from "../Buttons/FullButton";
import TestimonialSlider from "../Elements/TestimonialSlider";
import ReviewModal from "../Elements/ReviewModal";

export default function Blog() {
  const [showModal, setShowModal] = useState(false);
  const [userReviews, setUserReviews] = useState([]); // Only user-added reviews

  const handleAddReview = (newReview) => {
    // Validate all fields are filled
    if (newReview.text && newReview.author && newReview.company) {
      setUserReviews([...userReviews, newReview]);
      alert("Thank you! Your review has been added successfully!");
    } else {
      alert("Please fill in all fields before submitting your review.");
    }
  };

  // Initial testimonials that will always be there
  const initialTestimonials = [
    {
      text: "Professional team with great technical expertise. Our mobile app turned out better than we imagined.",
      author: "Maria Garcia", 
      company: "Scorpion Yacht",
      url:'https://play.google.com/store/apps/details?id=com.scorpionyacht&pcampaignid=web_share'
    },
    {
      text: "Reliable and efficient. They understood our business needs and provided perfect solutions.",
      author: "David Wilson",
      company: "DriveStreak",
       url:'https://play.google.com/store/apps/details?id=com.drivestreak&pcampaignid=web_share'
    },
    {
      text: "Excellent software development services! They delivered our project on time and exceeded expectations.",
      author: "John Smith",
      company: "Bitnoa",
       url:'https://bitnoa.com'
    },
    {
      text: "Outstanding quality and support. Will definitely work with them again on future projects.",
      author: "Sarah Brown",
      company: "Fragrance",
       url:'https://globalfragranceimports.com'
    }
  ];

  // Combine initial testimonials with user reviews
  const allTestimonials = [...initialTestimonials, ...userReviews];

  return (
    <Wrapper id="blog">
      <div className="lightBg" style={{padding: '50px 0'}}>
        <div className="container">
          <HeaderInfo>
            <div style={{display: 'flex',flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
              <h1 className="font40 extraBold">What They Say?</h1>
              <ReviewButton onClick={() => setShowModal(true)}>
                ✍️ Write a Review
              </ReviewButton>
            </div>
            <p className="font13">
              Hear what our clients and partners have to say about their experience working with us.
              <br />
              Their success stories and feedback drive us to deliver exceptional results every day.
            </p>
          </HeaderInfo>
          {/* Make sure you're passing the combined testimonials */}
          <TestimonialSlider testimonials={allTestimonials} />
        </div>
        <ReviewModal 
          show={showModal}
          onClose={() => setShowModal(false)}
          onAddReview={handleAddReview}
        />
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding-top: 20px;
`;
const HeaderInfo = styled.div`
  margin-bottom: 30px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;

const ReviewButton = styled.button`
  background: #7620ff;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 10px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: #0056b3;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
  }
`;











// import React, {useState} from "react";
// import styled from "styled-components";
// // Components
// import BlogBox from "../Elements/BlogBox";
// import FullButton from "../Buttons/FullButton";
// import TestimonialSlider from "../Elements/TestimonialSlider";
// import ReviewModal from "../Elements/ReviewModal";
// export default function Blog() {

//   const [showModal, setShowModal] = useState(false);
//     const [reviews, setReviews] = useState([]);
  
//     const handleAddReview = (newReview) => {
//       setReviews([...reviews, newReview]);
//     };

//       const testimonials = [
//     {
//       text: "Excellent software development services! They delivered our project on time and exceeded expectations.",
//       author: "John Smith",
//       company: "Tech Corp"
//     },
//     {
//       text: "Professional team with great technical expertise. Our mobile app turned out better than we imagined.",
//       author: "Maria Garcia", 
//       company: "StartUp Inc"
//     },
//     {
//       text: "Reliable and efficient. They understood our business needs and provided perfect solutions.",
//       author: "David Wilson",
//       company: "Enterprise Solutions"
//     },
//     {
//       text: "Outstanding quality and support. Will definitely work with them again on future projects.",
//       author: "Sarah Brown",
//       company: "Innovation Labs"
//     },
//     {
//       text: "Transformed our business with their custom software. Highly recommended for any development work.",
//       author: "Michael Taylor",
//       company: "Global Tech"
//     }
//   ];

//   return (
//     <Wrapper id="blog">
     
//       <div className="lightBg" style={{padding: '50px 0'}}>
          
//         <div className="container">
//           <HeaderInfo>
//             <div style={{display: 'flex',flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
//             <h1 className="font40 extraBold">What They Say?</h1>
//                <ReviewButton onClick={() => setShowModal(true)}>
//           ✍️ Write a Review
//         </ReviewButton>
//         </div>
// <p className="font13">
//   Hear what our clients and partners have to say about their experience working with us.
//   <br />
//   Their success stories and feedback drive us to deliver exceptional results every day.
// </p>
//           </HeaderInfo>
//           {/* <TestimonialSlider /> */}
//            <TestimonialSlider testimonials={testimonials} />
//         </div>
//           <ReviewModal 
//                 show={showModal}
//                 onClose={() => setShowModal(false)}
//                 onAddReview={handleAddReview}
//               />
//       </div>
//     </Wrapper>
//   );
// }

// const Wrapper = styled.section`
//   width: 100%;
//   padding-top: 20px;
// `;
// const HeaderInfo = styled.div`
//   margin-bottom: 30px;
//   @media (max-width: 860px) {
//     text-align: center;
//   }
// `;

// const ReviewButton = styled.button`
//   background: #7620ff;
//   color: white;
//   border: none;
//   padding: 10px 24px;
//   border-radius: 10px;
//   font-size: 14px;
//   cursor: pointer;
//   transition: all 0.3s ease;
  
//   &:hover {
//     background: #0056b3;
//     transform: translateY(-2px);
//     box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
//   }
// `;
